import { render } from "./tender_files.vue?vue&type=template&id=1e305a47"
import script from "./tender_files.vue?vue&type=script&lang=js"
export * from "./tender_files.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/tender/inside/tabs/tender_files.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e305a47"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e305a47', __exports__)) {
    console.log('reload')
    api.reload('1e305a47', __exports__)
  }
  
  module.hot.accept("./tender_files.vue?vue&type=template&id=1e305a47", () => {
    console.log('re-render')
    api.rerender('1e305a47', render)
  })

}


export default __exports__